import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy, SimpleChanges } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import { ModoBusqueda } from '../../shared/modo-busqueda.enum';

import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { FiltroArticuloPipe } from '../../filtro-articulo.pipe';

import { Product } from "../../models/product.model";
import { ProductsService } from "../../services/products.service";
import { cantidadesService } from "../../services/cantidades.service";
import {
    PopoverController,
    ModalController,
    LoadingController,
    IonInfiniteScroll,
    ToastController,
    NavController
} from "@ionic/angular";
import { GlobalService } from "../../services/global.service";
import { CartService } from "../../services/cart.service";
import { ApiService } from "../../api.service";
import { Storage } from "@ionic/storage";
import { Router, ActivatedRoute } from "@angular/router";
import { Carro } from "../../models/carro.model";
import { CategoryService } from "../../services/category.service";

import { ProductDetailsComponent } from "../../pages/product-details/product-details.component"


@Component({
    selector: 'app-barra-search',
    templateUrl: './barra-search.component.html',
    styleUrls: ['./barra-search.component.scss'],
})
export class barraSearch implements OnInit, OnDestroy {

    @ViewChild(IonInfiniteScroll, { static: false })
    infiniteScroll: IonInfiniteScroll;

    private searchChanged$ = new Subject<string>();
    private destroy$ = new Subject<void>();

    ModoBusqueda = ModoBusqueda;

    public rutaIcono: string = "";
    public searchTerm: string = "";
    public isOptionSearchOpen: boolean = false;
    public textoComoBusco: string = "Buscar productos";

    public modoBusqueda : ModoBusqueda = ModoBusqueda.contiene;

    @Output() filtro: EventEmitter<Product[]> = new EventEmitter();

    @Output() visualizacion: EventEmitter<number> = new EventEmitter();

    @Input() products: Product[];
    
    private productOriginal : Product[] = [];

    private grid: number;

    @Input() item: Product;
    @Input() accesoBD : boolean = false;

    @Input() pantalla : string;

    private cartProducts: Carro;

    showBotonesComoBusco = false;
    primeraCarga: boolean = true;
    

    private incremento = 10;

    constructor(
        private navController: NavController,
        private activeRoute: ActivatedRoute,
        private cartService: CartService,
        private route: ActivatedRoute,
        private nativeStorage: NativeStorage,
        public popoverController: PopoverController,
        private productsService: ProductsService,
        public storage: Storage,        
        public ctdadService: cantidadesService,
        public modalController: ModalController,
        public global: GlobalService,
        public loadingController: LoadingController,
        public apiService: ApiService,
        public toastController: ToastController,
        private categoryService: CategoryService

    ) {
    this.searchChanged$
      .pipe(
        debounceTime(1000),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const pipe = new FiltroArticuloPipe();
        console.log( this.products );
        if( this.productOriginal.length < 1 ) this.productOriginal = this.products; 
        console.log( this.productOriginal );
        console.log('pantalla ha cambiado:', this.pantalla);
        this.filtro.emit(            
          pipe.transform(this.productOriginal, this.searchTerm, this.modoBusqueda)
        );
      });
  }


    ngOnChanges(changes: SimpleChanges): void 
    {
        if (changes['pantalla']) {
            console.log('pantalla ha cambiado:', changes['pantalla'].currentValue);
        }
        console.log('pantalla ha cambiado:', changes);
    }
    ionViewDidEnter()
    {
        console.log("ionViewDidEnter.this.pantalla",this.pantalla);
    }

    ngOnInit() 
    {
        console.log("this.pantalla",this.pantalla);
        this.modoBusqueda = this.stringToModo( this.nativeStorage.getItem('modoBusqueda') );
        this.getIconoPorModo();
    }


     getIconoPorModo()
     {

        switch (this.modoBusqueda) 
        {
            case ModoBusqueda.empieza:
                 this.rutaIcono = '/assets/icon/btns/empieza.svg';
                 break;
            case ModoBusqueda.contiene:
                 this.rutaIcono ='/assets/icon/btns/contiene.svg';
                 break;
            case ModoBusqueda.acaba:
                 this.rutaIcono ='/assets/icon/btns/termina.svg';
                 break;
            default:
                 this.rutaIcono = '/assets/icon/btns/empieza.svg';
        }
    }

    ngOnDestroy(): void 
    {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onInputChanged(event: any) 
    {
        this.searchChanged$.next();
    }

    mostrarDiv() 
    {
        this.showBotonesComoBusco = false; // Reinicia clase si ya estaba visible
        
        
        setTimeout(() => {
                            this.primeraCarga = false;
                            this.showBotonesComoBusco = true;
                             }, 10); // Fuerza animación reiniciando el DOM
        console.log(this.showBotonesComoBusco);
    }


    ocultarDiv(_modoBsqda : ModoBusqueda) 
    {
        if( _modoBsqda != undefined)
            this.modoBusqueda = this.stringToModo(_modoBsqda);

        this.showBotonesComoBusco = false; // Reinicia clase si ya estaba visible
        this.getIconoPorModo();
    }

    async okClick() 
    {
        //this.products = await this.apiService.getBusqueda("?artic[codigo]=_82_&fami[codigo]=_100_&fami[codigo]=('10021','10025')");
        //const pipe = new FiltroArticuloPipe();
        switch( this.modoBusqueda )
        {
            case ModoBusqueda.codigoExacto:
                this.filtro.emit(await this.apiService.getBusqueda("?artic[codigo]="+this.searchTerm));        
                break;
            case ModoBusqueda.contiene:
                this.filtro.emit(await this.apiService.getBusqueda("?artic[descri]=_"+this.searchTerm+"_"));        
                break;
            case ModoBusqueda.empieza:
                this.filtro.emit(await this.apiService.getBusqueda("?artic[descri]="+this.searchTerm+"_"));        
                break;
            case ModoBusqueda.acaba:
                this.filtro.emit(await this.apiService.getBusqueda("?artic[descri]=_"+this.searchTerm));        
                break;
        }
        console.log( this.products );
        console.log( this.productOriginal );
        //this.retorno.emit(await this.apiService.getBusqueda("?artic[codigo]=_82_&fami[codigo]=_100_&fami[codigo]=('10021','10025')"));
    }

    showHidenOpciones() 
    {
        this.isOptionSearchOpen = !this.isOptionSearchOpen;
    }

    busquedaPorCodigo()
    {   
        this.modoBusqueda = ModoBusqueda.codigoExacto;
        this.searchTerm = '';
        this.textoComoBusco = "Buscar por código";    
        this.isOptionSearchOpen = false; // Oculta el menú después de hacer clic en la opción
        this.nativeStorage.setItem('modoBusqueda', this.modoBusqueda);
        
    }

    busquedaPorContenida()
    {
        this.modoBusqueda = ModoBusqueda.codigoDescripcion;
        this.searchTerm = '';
        this.textoComoBusco = "Contiene....";
        this.isOptionSearchOpen = false; // Oculta el menú después de hacer clic en la opción
        this.nativeStorage.setItem('modoBusqueda', this.modoBusqueda);
    }

    descripcion()
    {
        this.modoBusqueda = ModoBusqueda.contiene;
        this.searchTerm = '';
        this.textoComoBusco = "Descripción";
        this.isOptionSearchOpen = false; // Oculta el menú después de hacer clic en la opción
        this.nativeStorage.setItem('modoBusqueda', this.modoBusqueda);
    }

    stringToModo(_input) : ModoBusqueda
    {
        switch (_input) 
        {
            case 1 :
                 return ModoBusqueda.empieza;
            case 2:
                 return ModoBusqueda.contiene;
            case 3:
                 return ModoBusqueda.acaba;
            case 4:
                 return ModoBusqueda.codigoDescripcion;
            case 5:
                 return ModoBusqueda.codigoExacto;
        default:
             return ModoBusqueda.empieza;
        }
    }

    changeView(_modo)
    {
        this.grid = _modo;
        this.visualizacion.emit(_modo);
        this.nativeStorage.setItem('visualizacion'+this.pantalla, _modo);        
    }

}
